import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 1.5rem;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 240px;

  span {
    font-family: IBM Plex Sans;
    color: var(--grey-100);
  }
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 1rem;
  column-gap: 2rem;
  margin-bottom: 0.7rem;

  width: 100%;

  input {
    width: 100%;
  }
`;

export const DocumentContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1.5fr 1fr;
  column-gap: 1rem;
  margin-bottom: 0;

  div {
    width: 100%;

    input {
      width: 100%;
    }
  }
`;
